import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchResults } from '../searchResults';
import { Court } from './court';

@JsonObject('CourtSearchResults')
export class CourtSearchResults extends SearchResults {
    @JsonProperty('results', [Court])
    results: Court[] = [];
}
